import { render } from "./ContractExpirationShow.vue?vue&type=template&id=2faec98e&scoped=true"
import script from "./ContractExpirationShow.vue?vue&type=script&lang=js"
export * from "./ContractExpirationShow.vue?vue&type=script&lang=js"

import "./ContractExpirationShow.vue?vue&type=style&index=0&id=2faec98e&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faec98e"]])

export default __exports__